exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".covid-19-preferred-connection-date-section.nullify-section-margin-top{margin-bottom:-20px}.covid-19-confirmation-text{color:#eb4e00}div.covid-19-confirmation-text{margin-top:20px}.covid-19-tickbox label{color:#fd6c00}.essential-question-section{width:100%}.essential-question-section label{padding-top:24px}.essential-question-section .form-checkbox-label{padding-top:10px}@media (min-width:992px){.essential-question-section .essential-business-category{max-width:50%;padding-right:15px}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/checkout/PreferredConnectionDate/Covid19Confirmation.scss
 ** module id = 1233
 ** module chunks = 0
 **/